import type {Page, Result, UseCase} from 'framework';
import type {ScheduleError} from '../../domain/errors';
import type {ScheduleTemplateOption} from '../../domain/schedule-template-option';
import type {ListScheduleTemplatesInput, ScheduleRepository} from '../ports/schedule.repository';

export class ListScheduleTemplates implements UseCase<
  [ListScheduleTemplatesInput],
  Page<ScheduleTemplateOption>
> {
  constructor(private readonly repository: ScheduleRepository) {}

  execute(
    input: ListScheduleTemplatesInput,
  ): Promise<Result<Page<ScheduleTemplateOption>, ScheduleError>> {
    return this.repository.listTemplates(input);
  }
}
